import { Download } from "@mui/icons-material";
import { Box, Button, Dialog, IconButton, Stack, SvgIcon } from "@mui/material";
import XIcon from "@untitled-ui/icons-react/build/esm/X";
import { FC, useState } from "react";
import { useBoolean } from "usehooks-ts";
import PdfIcon01 from "~/icons/untitled-ui/duocolor/pdf-icon-01";
import { useGetFileDownloadUrl } from "~/queries/useGetFileDownloadUrl";
import { IMAGE_FILE_EXTENSIONS } from "~served/configs";
import { PaymentVerification } from "~served/types/db";
export const AttachmentThumbnail: FC<{
  a: PaymentVerification["attachment"];
}> = ({
  a
}) => {
  const getFileDownloadUrl = useGetFileDownloadUrl();
  const [paymentVerification, setPaymentVerification] = useState<PaymentVerification["attachment"] | undefined>();
  const {
    value: isViewPaymentVerificationDialogDialogOpen,
    setTrue: openViewPaymentVerificationDialogDialog,
    setFalse: closeViewPaymentVerificationDialogDialog
  } = useBoolean(false);
  if (!a) return null;
  const handleOpenViewPaymentVerificationDialog = (attachment: PaymentVerification["attachment"]) => {
    if (!attachment) return;
    setPaymentVerification(attachment);
    openViewPaymentVerificationDialogDialog();
  };
  const handleCloseViewPaymentVerificationDialog = () => {
    setPaymentVerification(undefined);
    closeViewPaymentVerificationDialogDialog();
  };
  return <>
			{isViewPaymentVerificationDialogDialogOpen && <ViewPaymentVerificationDialog attachment={paymentVerification!} onClose={handleCloseViewPaymentVerificationDialog} />}
			<Box sx={{
      display: "flex",
      gap: 2,
      border: "1px solid #ccc",
      borderRadius: 2,
      p: 1
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
				{IMAGE_FILE_EXTENSIONS.includes(a.extension.toLocaleLowerCase()) && <img src={a.url} alt={a.name} style={{
        height: 40,
        width: 40,
        borderRadius: 4
      }} onClick={() => handleOpenViewPaymentVerificationDialog(a)} />}
				{"pdf".includes(a.extension.toLocaleLowerCase()) && <PdfIcon01 onClick={() => handleOpenViewPaymentVerificationDialog(a)} />}
				<Button variant="contained" color="inherit" sx={{
        mr: 1
      }} onClick={async () => {
        const res = await getFileDownloadUrl.mutateAsync({
          key: a.url
        });
        const response = await fetch(res); // do NOT add headers
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const b = document.createElement("a");
        b.href = blobUrl;
        b.download = ""; // your desired filename
        b.click();
        URL.revokeObjectURL(blobUrl);
      }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
					<SvgIcon color="action" data-sentry-element="SvgIcon" data-sentry-source-file="index.tsx">
						<Download data-sentry-element="Download" data-sentry-source-file="index.tsx" />
					</SvgIcon>
				</Button>
			</Box>
		</>;
};
const ViewPaymentVerificationDialog: FC<{
  attachment: PaymentVerification["attachment"];
  onClose: () => void;
}> = ({
  attachment,
  onClose
}) => {
  const {
    url,
    name,
    extension
  } = attachment;
  return <Dialog open fullWidth maxWidth="md" data-sentry-element="Dialog" data-sentry-component="ViewPaymentVerificationDialog" data-sentry-source-file="index.tsx">
			<Stack sx={{
      height: "80dvh",
      overflow: "auto"
    }} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
				<IconButton color="inherit" onClick={onClose} data-sentry-element="IconButton" data-sentry-source-file="index.tsx">
					<SvgIcon data-sentry-element="SvgIcon" data-sentry-source-file="index.tsx">
						<XIcon data-sentry-element="XIcon" data-sentry-source-file="index.tsx" />
					</SvgIcon>
				</IconButton>
				{IMAGE_FILE_EXTENSIONS.includes(extension.toLocaleLowerCase()) && <img src={url} alt={name} style={{
        maxWidth: "100%",
        borderRadius: 4
      }} />}
				{"pdf".includes(extension.toLocaleLowerCase()) && <iframe src={url} style={{
        maxWidth: "100%",
        height: "90%",
        borderRadius: 4
      }} />}
			</Stack>
		</Dialog>;
};